import { render, staticRenderFns } from "./mainCompetitor.vue?vue&type=template&id=33fa8b03&scoped=true"
import script from "./mainCompetitor.vue?vue&type=script&lang=js"
export * from "./mainCompetitor.vue?vue&type=script&lang=js"
import style0 from "./mainCompetitor.vue?vue&type=style&index=0&id=33fa8b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa8b03",
  null
  
)

export default component.exports